import api, {
  buildQueryParams,
  IFilters,
  IGetQueryParams,
  // IGetQueryParams,
  IPaginatedRepsonse,
} from '../index';
import { IUser } from '../user';

interface IGetNotesResponse {
  notes: INote[];
  user: IUser;
}

export interface INote {
  id: number;
  body: string;
  user: IUser;
  created_at: string;
}

export interface IGetNotesParams {
  task_id?: number;
  project_id?: number;
  document_id?: number;
}
export interface IGetNotesQueryParams {
  task_id?: number;
  project_id?: number;
  document_id?: number;
}

export interface INotesQueryParams {}

export const notesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getNotes: builder.query<
      IPaginatedRepsonse<INote>,
      IGetQueryParams<IGetNotesQueryParams>
    >({
      query: (params) => `/notes${buildQueryParams(params)}`,
    }),
    createNote: builder.mutation<
      INote,
      {
        body: string;
        task_id?: number;
        project_id?: number;
        document_id?: number;
      }
    >({
      query: (body) => {
        const note = {
          note: {
            body: body.body,
            task_id: body.task_id,
            project_id: body.project_id,
            document_id: body.document_id,
          },
        };

        return {
          url: `/notes`,
          method: 'POST',
          body: note,
        };
      },
      transformResponse: (response: { note: INote }) => response.note,
    }),

    updateNote: builder.mutation<INote, { note: Partial<INote> }>({
      query: (body: { note: Partial<INote> }) => {
        return {
          url: `/notes/${body.note.id}`,
          method: 'PUT',
          body,
        };
      },

      transformResponse: (response: { note: INote }) => response.note,
    }),
    deleteNote: builder.mutation<any, number>({
      query: (id: number) => ({
        url: `/notes/${id}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useLazyGetNotesQuery,
  useCreateNoteMutation,
  useDeleteNoteMutation,
  useGetNotesQuery,
} = notesApi;
